/*
 * Tenue — cta-bar.js
 * Sticky buy bar.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     <cta-bar>: sticky buy bar.
     ------------------------------------------------------------------------ */
  if (!customElements.get('cta-bar')) {
    class CtaBar extends HTMLElement {
      connectedCallback() {
        this.target = document.getElementById(`ProductSubmit-${this.dataset.sectionId}`);
        this.button = this.querySelector('[data-cta-bar-button]');
        if (!this.target) return;
        if (this.button) {
          this.button.disabled = this.target.disabled;
          this.button.addEventListener('click', () => this.handleClick());
        }
        this.observer = new IntersectionObserver(([entry]) => this.toggle(!entry.isIntersecting), {
          threshold: 0.5,
        });
        this.observer.observe(this.target);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        document.documentElement.style.removeProperty('--cta-bar-height');
      }

      toggle(visible) {
        /* Reserves room at the end of the page so the bar never hides the footer. */
        document.documentElement.style.setProperty('--cta-bar-height', visible ? `${this.offsetHeight}px` : '0px');
        if (visible) {
          this.setAttribute('data-visible', '');
          this.removeAttribute('aria-hidden');
          this.inert = false;
        } else {
          this.removeAttribute('data-visible');
          this.setAttribute('aria-hidden', 'true');
          this.inert = true;
        }
      }

      handleClick() {
        const picker = document.getElementById(`VariantPicker-${this.dataset.sectionId}`);
        if (picker || this.target.disabled || !this.target.form) {
          this.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const focusTarget = picker ? picker.querySelector('input:checked, select') : this.target;
          if (focusTarget) focusTarget.focus({ preventScroll: true });
          return;
        }
        this.target.form.requestSubmit(this.target);
      }
    }
    customElements.define('cta-bar', CtaBar);
  }
})();
